import React from 'react'
import { TranslationResult } from 'shared/libraries/translation/src'
import { Brand } from 'shared/model'
import { Box, Flex, Image, Text, ThemeUIStyleObject } from 'theme-ui'

import { NeoButton } from '@neo-ds/components-react/button'

import { useTranslation } from '../context/TranslationContext'
import { getLogoPath } from '../utils/url.utils'

export interface LoginBannerProps {
  loginUrl: string
  infotext: TranslationResult | string
  brand: Brand
}

type LoginBannerStyle = {
  loginBannerContainer: ThemeUIStyleObject
  loginBannerBox: ThemeUIStyleObject
  logoStyle: ThemeUIStyleObject
  textStyle: ThemeUIStyleObject
  loginLinkStyle: ThemeUIStyleObject
}

const loginBannerStyle: LoginBannerStyle = {
  loginBannerContainer: { flexWrap: ['wrap', 'nowrap', 'nowrap'] },
  loginBannerBox: {
    flexDirection: ['column', 'row', 'row'],
    alignItems: 'center',
    minWidth: '100%',
    justifyContent: 'flex-start',
  },
  logoStyle: { width: '100px', minWidth: '78px', minHeight: '52px' },
  textStyle: { marginBottom: ['32px', 0, 0], marginRight: [0, '24px'], width: '100%' },
  loginLinkStyle: { width: ['100%', '276px', '276px'], justifySelf: 'flex-end', textDecoration: 'none' },
}

export const LoginBanner: React.FC<LoginBannerProps> = ({ loginUrl, infotext, brand }) => {
  const { t } = useTranslation()

  const logoPath = getLogoPath(brand)
  const isBrandBmw = brand === Brand.bmw
  const cssBrand = brand === Brand.toyota ? 'BMW' : brand.toUpperCase()

  return (
    <Flex bg="db10" p={5} sx={loginBannerStyle.loginBannerContainer}>
      <Flex data-testid="login-box" sx={loginBannerStyle.loginBannerBox}>
        {isBrandBmw && (
          <Flex sx={loginBannerStyle.logoStyle}>
            <Image src={logoPath} alt="" />
          </Flex>
        )}
        <Text
          ml={isBrandBmw ? 4 : 0}
          sx={loginBannerStyle.textStyle}
          variant={brand === Brand.mini ? 'body3' : 'body2'}
        >
          {infotext}
        </Text>
        <Box className={cssBrand} sx={loginBannerStyle.loginLinkStyle}>
          <NeoButton data-testid="login-link" brand={cssBrand} variant="tertiary">
            <a href={loginUrl}>{t('LOGIN_BTN_LOGIN', 'SID_CD_FP')}</a>
          </NeoButton>
        </Box>
      </Flex>
    </Flex>
  )
}
